import { Component, Input } from '@angular/core';

@Component({
  selector: 'large-button',
  standalone: true,
  template: `
    <button [disabled]="buttonDisabled" class="large-button">
      {{ buttonText }}
    </button>
  `,
  styles: `
    .large-button {
      padding: 10px 20px;
      min-width: 410px;
      height: 78px;
      font-size: 27px;
      border-radius: 8px;
      font-weight: 700;
      background-color: var(--qbuilt-green);
    }
    .large-button:disabled {
      background-color: var(--qbuilt-disabled-grey);
    }
  `
})
export class LargeButtonComponent {
  @Input() buttonText: string = 'Default Button';
  @Input() buttonDisabled: boolean = false;
}